import { Divider, FlexBox, TextSmall } from '@trmediaab/zebra';

const AltContentDivider = () => (
  <FlexBox alignItems="center">
    <Divider flexGrow="1" mt="1px" />
    <TextSmall px={{ _: 2, lg: '2,5' }}>eller</TextSmall>
    <Divider flexGrow="1" mt="1px" />
  </FlexBox>
);

export default AltContentDivider;
